import { diffDays } from './utils'

export class PerformanceGuaranteeController {
  getPerformanceDays() {
    return diffDays(this.performanceGuarantee.DateStart, this.performanceGuarantee.DateEnd)
  }
}
PerformanceGuaranteeController.$inject = []